<template>
  <v-layout justify-center>
    <v-card>
      <!--タイトル-->
      <v-card-title class="head title-center" style="display:block; text-align:center;">
        {{ title }}
        <!--タイトル横アイコン-->
        <v-icon color="black" class="ml-2 mt-1">{{ icon }}</v-icon>
      </v-card-title>

      <!--概要-->
      <Seachtitle></Seachtitle>
      <!--概要-->
      <Summary></Summary>
      <!--機能-->
      <Function></Function>
      <!--動作環境-->
      <Environment></Environment>
      <!--実績-->
      <Performance></Performance>
      <!--トピックス-->
      <Topics></Topics>
      <!--お問い合わせ-->
      <contact></contact>
    </v-card>
  </v-layout>
</template>

<style>
.title-center {
  justify-content: center;
}
</style>

<script>
import Summary from './Summary'
import Function from './Function'
import Environment from './Environment'
import Performance from './Performance'
import Topics from './Topics'
import contact from '../contact'

export default {
  data () {
    return {
      // タイトル
      title: 'E-learningシステム',
      // タイトル横のアイコン
      icon: 'mdi-school'
    }
  },
  components: {
    Summary,
    Function,
    Environment,
    Performance,
    Topics,
    contact
  }
}
</script>
